import { render, staticRenderFns } from "./PlusHeaderNotification.vue?vue&type=template&id=65ea18fe"
import script from "./PlusHeaderNotification.vue?vue&type=script&lang=js"
export * from "./PlusHeaderNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports